import styled from 'styled-components'

export const SlashCommandCard = styled.div<{
  $isEditMode?: boolean
  $disableHovering?: boolean
}>`
  background: ${({ theme }) => theme.forecast.cardGroupBackground};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.5rem;
  overflow: hidden;
  margin: 0.25rem 0;
  cursor: ${({ $isEditMode, $disableHovering }) =>
    $isEditMode === false && !$disableHovering ? 'pointer' : 'default'};
  transition: all 0.2s ease;

  ${({ $isEditMode, $disableHovering, theme }) =>
    $isEditMode === false &&
    !$disableHovering &&
    `
    &:hover {
      border-color: ${theme.forecast.primary};
      box-shadow: 0 0 0 1px ${theme.forecast.primary}20;
    }
  `}
`

export const SlashCommandCardHeader = styled.div`
  padding: 0.75rem;
  background: ${({ theme }) => theme.forecast.cardGroupBackground};
  border-bottom: 1px solid ${({ theme }) => theme.forecast.border};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SlashCommandCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: ${({ theme }) => theme.forecast.primary}20;
  color: ${({ theme }) => theme.forecast.primary};
  border-radius: 0.25rem;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
`

export const SlashCommandCardInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const SlashCommandCardName = styled.h4`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.forecast.defaultText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SlashCommandCardType = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
`

export const SlashCommandCardBody = styled.div<{ $isEditMode: boolean }>`
  padding: 0.75rem;
  ${({ $isEditMode, theme }) =>
    $isEditMode
      ? `
    background: ${theme.forecast.background1};
    color: ${theme.forecast.secondaryText};
    font-style: italic;
    text-align: center;
  `
      : `
    background: ${theme.forecast.cardGroupBackground};
  `}
`

export const SlashCommandCardMeta = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
`

export const SlashCommandCardDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.forecast.defaultText};
  line-height: 1.4;
`

export const SlashCommandChip = styled.span`
  background: ${({ theme }) => theme.forecast.cardGroupBackground};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  color: ${({ theme }) => theme.forecast.defaultText};
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0 0.125rem;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.forecast.primary};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.forecast.primary}20;
  }
`

export const SlashCommandChipIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  background: ${({ theme }) => theme.forecast.primary}20;
  color: ${({ theme }) => theme.forecast.primary};
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 600;
  flex-shrink: 0;
`

export const SlashCommandModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const SlashCommandModalContent = styled.div`
  background: ${({ theme }) => theme.forecast.cardGroupBackground};
  border-radius: 0.5rem;
  padding: 1.5rem;
  max-width: 400px;
  width: 90%;
  border: 1px solid ${({ theme }) => theme.forecast.border};
`

export const SlashCommandModalHeader = styled.h3`
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.forecast.defaultText};
`

export const SlashCommandModalBody = styled.div`
  color: ${({ theme }) => theme.forecast.secondaryText};
  margin-bottom: 1.5rem;
  line-height: 1.4;
`

export const AssetVizContainer = styled.div`
  height: 30rem;
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 0.25rem;
  margin: 1rem;
  display: flex;
  flex-direction: column;
`

export const ClickableSlashCommandCardName = styled(SlashCommandCardName)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
